import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Header.css";

export default function Header() {
  const { logout } = useAuth();

  return (
    <header className="app-header">
      <Link to="/" className="header-logo">
        <img src="/LogoH512.png" alt="Arkheops" className="logo-image" />
        <span className="logo-text">ADMIN</span>
      </Link>
      <button className="header-logout" onClick={logout}>
        Sign out
      </button>
    </header>
  );
}
